import React, { useEffect, useState } from 'react'
import { BASEURL } from '../../config'
import axios from 'axios'
import useAccountStore from '../../stores/account'
import { getRefreshToken, setRefreshToken } from '../../utils/localStorageUtil'
import { useNavigate } from 'react-router-dom'

const LoginPage = (props:any) => {
    const [ID, setID] = useState('')
    const [password, setPassword] = useState('')
    
    const navigate = useNavigate()
    const {setAccessToken} = useAccountStore()

    const handleIDChange = (e:any) => { setID(e.target.value) }
    const handlePasswordChange = (e:any) => { setPassword(e.target.value) }
    
    const execLogin = async() => {
        await axios.post(`${BASEURL}/auth/login`, {userID:ID, password:password})
        .then(response => response.data).then(result => {
            if(result.status === "success") {
                setAccessToken(result.data.accessToken)
                setRefreshToken(result.data.refreshToken)

                alert('Login Success')

                navigate('/main', {replace:true})
            } else { 
                // throw new Error(result.message) 
                alert(result?.data.message ?? "Login Failed")
            }
        })
        .catch(e=>{
            if(e.response) alert(e.response.data.message)
            else { alert('Login Failed') }
        })
    }

    return (
        <div id="main_contents">
            <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', height:'100vh'}}>
                <div style={{display:'flex', flexDirection:'column', margin:'auto', width:'500px', height:'120px', background:'#DCFDFF', border:'1px solid #ccc', borderRadius:'10px', padding:'5px'}}>
                    <div style={{display:'flex', marginTop:'5px', marginBottom:'5px'}}>
                        <p style={{width:'50px', fontSize:'12px', padding:'4px 5px', marginLeft:'5px', marginRight:'5px'}}>ID</p>
                            <input type="text" 
                            style={{width:'150px', alignItems:'center', textAlign:'center', marginRight:'5px',
                            borderRadius:'5px', fontSize:'12px', background:'#FFFFFF', padding:'4px 5px'}}
                            placeholder="Username" value={ID} onChange={handleIDChange} />
                    </div>
                    <div style={{display:'flex', marginTop:'5px', marginBottom:'5px'}}>
                        <p style={{width:'50px', fontSize:'12px', padding:'4px 5px', marginLeft:'5px', marginRight:'5px'}}>Password</p>
                            <input type="password" 
                            style={{width:'150px', alignItems:'center', textAlign:'center', marginRight:'5px',
                                    borderRadius:'5px', fontSize:'12px', background:'#FFFFFF', padding:'4px 5px'}}
                            placeholder="Password" value={password} onChange={handlePasswordChange}/>
                    </div>
                    <button style={{width:'80px', height:'40px', margin:'5px auto', borderRadius:'5px', background:'#51D7DF', color:'#FFFFFF'}}
                    onClick={execLogin}>Login</button>
                </div>
            </div>
        </div>
    )
}

export default LoginPage
